export default {"src":"https://app.iconosquare.com/_next/static/media/pentest.763e1b45.svg","height":100,"width":180,"blurWidth":0,"blurHeight":0};